import axios from '@/utils/request.js'

export const getCompanyEmpList = (params) => { // 获取首页数据
  return axios.post('/goods/gas/company/getCompanyOrgAndEmp', params)
}
